module.exports = __webpack_public_path__ + "img/menuham.3cf209d1.svg";